import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as ENV } from './../../../environments/environment';
import * as apiUrl from '../constants/api-urls';
import { Subject } from 'rxjs';
import * as constant from './../../shared/constants/constants';
import { componentNavigationLabel } from 'src/app/core/enum';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  api_url = `${ENV.API_ENDPOINT}`;
  navigation_open = new Subject();

  constructor(private http:HttpClient, private translateService : TranslateService) { }

  convertKeys(navigationIconOnClick: any,navigation_data:any): any {
    const result:any = {};

    for (const key in navigation_data) {
      if (key === 'navigation_name') {
        if(navigation_data['navigation_code'])
        {  let navigation_label = componentNavigationLabel[navigation_data['navigation_code'] as keyof typeof componentNavigationLabel] || navigation_data['navigation_name']
          result['label'] = this.translateService.instant(navigation_label);
          result['tooltip'] =  this.translateService.instant(navigation_label);
          result['icon'] = navigation_data['navigation_icon'];
        }
      } 
      else if(key == 'submenu_name'){
        if(navigation_data['submenu_code'])
        { let navigation_label = componentNavigationLabel[navigation_data['submenu_code'] as keyof typeof componentNavigationLabel] || navigation_data['submenu_name']
          result['label'] = this.translateService.instant(navigation_label);
          result['tooltip'] =  this.translateService.instant(navigation_label);
          result['navigation_code'] = navigation_data['submenu_code']
        }
      }
      else if (key === 'submenu') {
         result['items'] = navigation_data[key].map(this.convertKeys.bind(this,navigationIconOnClick));
      } 
      else {
        result[key] = navigation_data[key];
        result['command'] = navigationIconOnClick
      }
      result['routerLink'] = constant.navigation.componentNavigation[result['navigation_code'] as keyof typeof constant.navigation.componentNavigation]
      if (result['navigation_code'] == constant.common.home_code)
        result['routerLinkActiveOptions'] = { exact: true }
    }

    return result;
  }

  convertMenuData(originalData: any[],navigationIconOnClick:any): any[] {
    return originalData.map(this.convertKeys.bind(this,navigationIconOnClick));
  }

  getMenuData(paylaod:any){
    let url = this.api_url + apiUrl.dashboard.getMenuList
    return this.http.post(url, paylaod)
  }

	navigationCheck(){
		this.navigation_open.next(false)
	}

}